<template>
  <div class="box box-info">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Attendance Request" :visible.sync="displayBasic" @show="checkNepaliDateOrEnglish"
              :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="employeeName">Employee Name</label>
             <AutoComplete v-model="epmloyee" filterMatchMode='contains'
                 :suggestions="filteredEmployees" @complete="searchItem($event)"
                  field="name" ref="itm">
                 </AutoComplete>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="attendanceDate">Attendance Date</label>
            <date-picker v-model="attendanceDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="attendanceDate"
                       v-model="attendanceDate"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="toDate">Date To</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="toDate"
                       v-model="toDate"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="logTime">Log Time</label>
            <!-- <Calendar v-model="logTime" cols="30" rows="5"  id="logTime" :timeOnly="true" hourFormat="12" /> -->
             <input type="time" id="workhours" class="p-inputtext p-component" v-model="logTimeStr"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="direction">Direction</label>
            <Dropdown v-model="direction" optionLabel="name" placeholder="Select Direction"
                      :filter="true" :options="directions"
                      :showClear="true" id="direction"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="returnTime">Return Time</label>
            <!-- <Calendar v-model="returnTime"  id="returnTime" :timeOnly="true" hourFormat="12" /> -->
             <input type="time" id="workhours" class="p-inputtext p-component" v-model="returnTimeStr"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="outPlace">Out Place</label>
            <InputText v-model="outPlace"  id="outPlace"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="remarks">Remarks</label>
            <Textarea v-model="remarks" cols="30" rows="5"  id="remarks"/>
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised"  @click.prevent="addAttendanceRequest" :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
      <DataTable :value="attendanceRequestList" :filters="filters" class="p-datatable-responsive p-datatable-gridlines" :rowsPerPageOptions="[100,500,1000]" :paginator="true" :rows="100">
      <Column header="S.N" field=""/>
      <Column header="Name" :sortable="true" field="employeeName"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['employeeName']" />
        </template>
      </Column>
      <Column header="Direction" :sortable="true" field="direction"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['direction']" />
        </template>
      </Column>
      <Column header="Date" :sortable="true" field="attendanceDate"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['attendanceDate']" />
        </template>
      </Column>
      <Column header="Log Time" :sortable="true" field="logTimeStr"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['logTimeStr']" />
        </template>
      </Column>
      <Column header="Date To" :sortable="true" field="dateTo"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['dateTo']" />
        </template>
      </Column>
      <Column header="Return Time" :sortable="true" field="returnTimeStr"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['returnTimeStr']" />
        </template>
      </Column>
      <Column header="Status" :sortable="true" field="status"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['status']" />
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editAttendacneRequest(slotProps.data)" />
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
        </template>
      </Column>
    </DataTable>
    </form>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import Textarea from 'primevue/textarea'
import AutoComplete from 'primevue/autocomplete'
import Calendar from 'primevue/calendar'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
export default {
  name: 'leaveRequestReport',
  data() {
    return {
      displayBasic: false,
      employeeName: '',
      employee: '',
      employeeId: 0,
      logTime: '',
      logTimeStr: '',
      returnTimeStr: '',
      direction: '',
      returnTime: '',
      outPlace: '',
      remarks: '',
      directions: [{name: 'Check In'}, {name: 'Check Out'}],
      loading: false,
      editing: false,
      holidayId: null,
      attendanceDate: null,
      toDate: null,
      employeeList: null,
      englishDateEnabled: true,
      filters: {}
    }
  },
  computed: {
    attendanceRequestList() {
      return this.$store.state.hr.attendanceRequestList
    }
  },
  mounted() {
    this.findAttendanceRequestList()
  },
  methods: {
    async findAttendanceRequestList() {
      await this.$store.dispatch('loadAttandanceList')
    },
    async addAttendanceRequest() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let attendance = {
        id: this.attendanceId,
        empId: this.employee.id,
        logTimeStr: this.logTimeStr,
        returnTimeStr: this.returnTimeStr,
        outPlace: this.outPlace,
        direction: this.direction,
        remarks: this.remarks,
        attendanceDate: this.attendanceDate,
        dateTo: this.dateTo
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createAttendanceRequest', attendance)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateAttendanceRequest', attendance)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    editAttendacneRequest(data) {
      this.editing = true
      this.payGradeId = data.id
      this.employeee = data.employee.id
      this.logTimeStr = data.logTimeStr
      this.returnTimeStr = data.returnTimeStr
      this.outPlace = data.outPlace
      this.direction = data.direction
      this.remarks = data.remarks
      this.attendanceDate = data.attendanceDate
      this.dateTo = data.dateTo
      this.openBasic()
    },
    reset() {
      this.name = ''
      this.displayBasic = false
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.displayBasic = false
    },
    checkNepaliDateOrEnglish() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    async deleteAttendanceRequest(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let attendance = {
        id: this.attendanceId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deleteAttendanceRequest', attendance)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Attendacne ' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.attendanceDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.attendanceDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#attendanceDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.attendanceDate = $('#attendanceDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    Dropdown,
    InputMask,
    DatePicker,
    Textarea,
    AutoComplete,
    Calendar,
    DataTable,
    Column
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// attendanceRequestReport.vue?2cd50b72